<template>
  <div class="q-gutter-md">
    <create-album-btn
      :client-id="clientId"
      color="primary"
      rounded
      @created="prepend"
    />
    <albums-table :client-id="clientId" ref="reports" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {
  Report,
  List,
} from '@/type';
import CreateAlbumBtn from '@/report/album/CreateAlbumBtn.vue';
import AlbumsTable from '@/report/album/AlbumsTable.vue';

export default defineComponent({
  components: { AlbumsTable, CreateAlbumBtn },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    prepend(report: Report) {
      (this.$refs.reports as List).prepend(report);
    },
  },
});
</script>
